import React from 'react';
import ReactDOM from 'react-dom';

import settings from '@dc/ui-library/src/config/settings';
import translations from '@dc/ui-library/src/config/translations';
import List from '@dc/ui-library/src/molecules/List/List';
import Popup from '@dc/ui-library/src/organisms/Popup/Popup';
import StayInTouchBlock from '@dc/ui-library/src/organisms/StayInTouchBlock/StayInTouchBlock';
import FormSubmitHandler from './FormSubmitHandler';
import domutils from '../../../domutils';

export function init() {
  const roots = document.querySelectorAll('[data-component="StayInTouchBlock"][data-auto-init]');
  const enabledChannels = settings['component.gdpr.enabled_channels'];
  let enabledChannelsList = [];

  if (enabledChannels && enabledChannels !== 'component.gdpr.enabled_channels') {
    enabledChannelsList = enabledChannels.split(',');
  }

  if (enabledChannelsList.length === 0) {
    return;
  }


  Array.from(roots).forEach((root) => {
    const parentForm = domutils.parents(root, (parent) => parent.tagName === 'FORM');
    const groupName = 'ourUpdates';

    ReactDOM.render(
      <FormSubmitHandler form={parentForm}>
        {({ hasValidationError, registerComponent, resetValidationError }) => (
          <StayInTouchBlock
            ref={(el) => registerComponent(el, groupName)}
            borderStyle={root.getAttribute('data-border-style') || 'none'}
            closeWhenAllChannelsOff
            contactChannelGroups={[
              {
                name: groupName,
                description: translations.stay_in_touch_channels_label,
                toggleDescription: translations.stay_in_touch_toggle_description,
                groupErrorMessage: translations.stay_in_touch_not_selected_message,
                hasValidationError,
                providesPopup: true,
                popupIconInteraction: 'special offer benefits',
                items: enabledChannelsList.map((channel) => ({
                  name: channel,
                  label: translations[`stay_in_touch_channels_${channel}`],
                  isChecked: root.getAttribute(`data-checkbox-${channel}-checked`) !== null
                }))
              }
            ]}
            headerSize={root.getAttribute('data-header-size') || 'bigger'}
            headerText={translations.lets_update_you}
            onLabel={translations.yes}
            offLabel={translations.no}
            onInteraction={resetValidationError}
            popupRenderer={(activePopup, closePopup) => {
              switch (activePopup) {
                case 'ourUpdates':
                  return (
                    <Popup title={translations.stay_in_touch_popup_title} onClose={closePopup}>
                      <strong>{translations.stay_in_touch_popup_content}</strong>
                      <List items={translations.stay_in_touch_popup_list.split('|')} />
                    </Popup>
                  );
                default:
                  return null;
              }
            }}
            privacyBoxDescription={translations.stay_in_touch_privacy_text}
            privacyBoxLabel={translations.stay_in_touch_privacy_label}
            expandableTextInteraction={'personal data: expand'}
          />
        )}
      </FormSubmitHandler>,
      root
    );
    root.removeAttribute('data-auto-init');
  });
}
